import React from "react"

function FooterA() {
  return (
    <svg fill="none" viewBox="0 0 266 150">
      <path fill="var(--solid)" d="M0 0h266v150H0z" />
      <rect
        x={61}
        y={85}
        width={35}
        height={3}
        rx={1.5}
        fill="var(--solid-900)"
      />
      <rect
        x={61}
        y={93}
        width={23}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={61}
        y={100}
        width={16}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={61}
        y={107}
        width={28}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={61}
        y={114}
        width={23}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={111}
        y={85}
        width={35}
        height={3}
        rx={1.5}
        fill="var(--solid-900)"
      />
      <rect
        x={111}
        y={93}
        width={23}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={111}
        y={100}
        width={16}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={111}
        y={107}
        width={28}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={111}
        y={114}
        width={23}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={161}
        y={85}
        width={35}
        height={3}
        rx={1.5}
        fill="var(--solid-900)"
      />
      <rect
        x={161}
        y={93}
        width={23}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={161}
        y={107}
        width={28}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={161}
        y={100}
        width={16}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={161}
        y={114}
        width={23}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={211}
        y={85}
        width={35}
        height={3}
        rx={1.5}
        fill="var(--solid-900)"
      />
      <rect
        x={211}
        y={93}
        width={23}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={211}
        y={100}
        width={16}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={211}
        y={107}
        width={28}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={211}
        y={114}
        width={23}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <path fill="var(--base-200)" d="M0 131h266v19H0z" />
      <rect
        x={20}
        y={139}
        width={41}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect
        x={222}
        y={139}
        width={25}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <circle cx={29} cy={94} r={9} fill="var(--main-500)" />
    </svg>
  )
}

export default FooterA;
